import { instance } from "@/modules";
import { CreateFitnessCenterBody } from "@/models";


export const createFitnessCenter = (params: CreateFitnessCenterBody) => {
    return instance.post<number>('/fitnessCenter/regist', null, { params: params });
};